import PropTypes from 'prop-types'
import { useEffect } from 'react'

import { esCobroPorPublicar } from '../../../constants/publicaciones.js'
import { useExposiciones } from '../../../hooks/useExposiciones.js'
import { InputField } from '../../../ui/components/index.js'
import { formatearNumeroAR } from '../../helpers/formatearNumeroAR'
import styles from './AdministrarPublicacion.module.css'

const Exposicion = ({
  idExposicionNueva,
  onChangeState,
  idCategoria,
  esScrap,
  precioUnitario,
  alicuota,
  bloqueado,
  mensajeBloqueo,
  esError,
  onAvisoChange,
  onCobroPorPublicarChange,
  onCargandoChange,
  esPresupuesto
}) => {
  const {
    exposiciones,
    aviso,
    cargando,
    esCobroPorPublicar: esSeleccionadaCobroPorPublicar
  } = useExposiciones({
    idCategoria,
    esScrap,
    precioUnitario,
    alicuota,
    idSeleccionada: idExposicionNueva
  })

  const handleChange = ({ name, value }) => {
    onChangeState(name, parseInt(value))
  }

  useEffect(() => {
    onAvisoChange?.(aviso)
  }, [aviso, onAvisoChange])

  useEffect(() => {
    onCobroPorPublicarChange?.(esSeleccionadaCobroPorPublicar)
  }, [esSeleccionadaCobroPorPublicar, onCobroPorPublicarChange])

  useEffect(() => {
    onCargandoChange?.(cargando)
  }, [cargando, onCargandoChange])

  const armarEtiqueta = (exposicion) => {
    const monto = formatearNumeroAR(exposicion.montoCalculado)

    if (esCobroPorPublicar(exposicion)) {
      return `Exposición ${exposicion.nombre} — ${monto} por publicar`
    }

    return esPresupuesto
      ? `Exposición ${exposicion.nombre}`
      : `Exposición ${exposicion.nombre} — ${exposicion.precio}% (${monto})`
  }

  return (
    <div className={styles.columnaLeft}>
      {exposiciones.map((exposicion) => (
        <InputField
          key={exposicion.idPublicacionExposicion}
          className={styles.input}
          type="radio"
          name="idPublicacionExposicion"
          label={armarEtiqueta(exposicion)}
          checked={idExposicionNueva === exposicion.idPublicacionExposicion}
          value={exposicion.idPublicacionExposicion}
          onChange={(e) => handleChange(e.target)}
          disabled={bloqueado}
        />
      ))}
      {bloqueado && mensajeBloqueo && (
        <small className={esError ? 'text-danger' : 'text-muted'}>{mensajeBloqueo}</small>
      )}
    </div>
  )
}

Exposicion.propTypes = {
  idExposicionNueva: PropTypes.number.isRequired,
  onChangeState: PropTypes.func.isRequired,
  idCategoria: PropTypes.number,
  esScrap: PropTypes.bool,
  precioUnitario: PropTypes.number,
  alicuota: PropTypes.number,
  bloqueado: PropTypes.bool,
  mensajeBloqueo: PropTypes.string,
  esError: PropTypes.bool,
  onAvisoChange: PropTypes.func,
  onCobroPorPublicarChange: PropTypes.func,
  onCargandoChange: PropTypes.func,
  esPresupuesto: PropTypes.bool
}

export default Exposicion
